/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Wren API
 * AI-powered relationship coaching platform API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionableRescheduleOfferOut,
  AnswersPatch,
  CheckinIn,
  CheckinStateOut,
  CoachedSessionOut,
  ConsentEnvelopeIn,
  ConsentEnvelopeOut,
  ConsentIn,
  ContactIn,
  ContactOut,
  CoupleAuthIn,
  CoupleAuthOut,
  CoupleOut,
  CouplePreviewOut,
  FeedbackIn,
  FeedbackStateOut,
  FlagMissingEmailOut,
  HTTPValidationError,
  ListPastSessionsMeSessionsPastGetParams,
  ListReportsParams,
  MeFeatureFlagsOut,
  PartnerProgressOut,
  PastSessionsOut,
  ReportOut,
  ReportViewedOut,
  ReportsOut,
  RescheduleCandidateSetOut,
  RescheduleOfferCreateIn,
  RescheduleOfferDeclineIn,
  RescheduleOfferMutationOut,
  RescheduleOfferOut,
  RescheduleOfferPickIn,
  SelectPartnerIn,
  SelectPartnerOut,
  SessionCancelIn,
  SessionCancelOut,
  SessionConfirmOut,
  SessionDeclineIn,
  SessionDeclineOut,
  SessionTokenRedeemIn,
  SessionTokenRedeemOut,
  SmsHandoffOut,
  TimezoneIn,
  TimezoneOut,
  VerificationSkipIn
} from '../wrenAPI.schemas';

import { customInstance } from '../../../api/client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Return the acting partner's couple payload (therapist, both partners, first session).
 * @summary Get Couple
 */
export type getCoupleMeCoupleGetResponse200 = {
  data: CoupleOut
  status: 200
}

export type getCoupleMeCoupleGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getCoupleMeCoupleGetResponseSuccess = (getCoupleMeCoupleGetResponse200) & {
  headers: Headers;
};
export type getCoupleMeCoupleGetResponseError = (getCoupleMeCoupleGetResponse422) & {
  headers: Headers;
};

export type getCoupleMeCoupleGetResponse = (getCoupleMeCoupleGetResponseSuccess | getCoupleMeCoupleGetResponseError)

export const getGetCoupleMeCoupleGetUrl = () => {


  

  return `/me/couple`
}

export const getCoupleMeCoupleGet = async ( options?: RequestInit): Promise<getCoupleMeCoupleGetResponse> => {
  
  return customInstance<getCoupleMeCoupleGetResponse>(getGetCoupleMeCoupleGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoupleMeCoupleGetQueryKey = () => {
    return [
    `/me/couple`
    ] as const;
    }

    
export const getGetCoupleMeCoupleGetQueryOptions = <TData = Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoupleMeCoupleGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>> = ({ signal }) => getCoupleMeCoupleGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCoupleMeCoupleGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>>
export type GetCoupleMeCoupleGetQueryError = HTTPValidationError


export function useGetCoupleMeCoupleGet<TData = Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupleMeCoupleGet>>,
          TError,
          Awaited<ReturnType<typeof getCoupleMeCoupleGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupleMeCoupleGet<TData = Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupleMeCoupleGet>>,
          TError,
          Awaited<ReturnType<typeof getCoupleMeCoupleGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupleMeCoupleGet<TData = Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Couple
 */

export function useGetCoupleMeCoupleGet<TData = Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupleMeCoupleGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCoupleMeCoupleGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Exchange a shared couple-link token for a couple-scoped session.

The /me analogue of the magic-link → JWT exchange, but couple-scoped: the opaque
shared-link token (minted by WP-B on ``ClientGroup.uuid``) is redeemed for a
couple-scoped JWT that resolves the couple and binds no person. The opener then
reads the roster (``/me/couple/preview``) and self-selects.
 * @summary Couple Auth
 */
export type coupleAuthMeCoupleAuthPostResponse200 = {
  data: CoupleAuthOut
  status: 200
}

export type coupleAuthMeCoupleAuthPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type coupleAuthMeCoupleAuthPostResponseSuccess = (coupleAuthMeCoupleAuthPostResponse200) & {
  headers: Headers;
};
export type coupleAuthMeCoupleAuthPostResponseError = (coupleAuthMeCoupleAuthPostResponse422) & {
  headers: Headers;
};

export type coupleAuthMeCoupleAuthPostResponse = (coupleAuthMeCoupleAuthPostResponseSuccess | coupleAuthMeCoupleAuthPostResponseError)

export const getCoupleAuthMeCoupleAuthPostUrl = () => {


  

  return `/me/couple/auth`
}

export const coupleAuthMeCoupleAuthPost = async (coupleAuthIn: CoupleAuthIn, options?: RequestInit): Promise<coupleAuthMeCoupleAuthPostResponse> => {
  
  return customInstance<coupleAuthMeCoupleAuthPostResponse>(getCoupleAuthMeCoupleAuthPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      coupleAuthIn,)
  }
);}
  



export const getCoupleAuthMeCoupleAuthPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>, TError,{data: CoupleAuthIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>, TError,{data: CoupleAuthIn}, TContext> => {

const mutationKey = ['coupleAuthMeCoupleAuthPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>, {data: CoupleAuthIn}> = (props) => {
          const {data} = props ?? {};

          return  coupleAuthMeCoupleAuthPost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CoupleAuthMeCoupleAuthPostMutationResult = NonNullable<Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>>
    export type CoupleAuthMeCoupleAuthPostMutationBody = CoupleAuthIn
    export type CoupleAuthMeCoupleAuthPostMutationError = HTTPValidationError

    /**
 * @summary Couple Auth
 */
export const useCoupleAuthMeCoupleAuthPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>, TError,{data: CoupleAuthIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof coupleAuthMeCoupleAuthPost>>,
        TError,
        {data: CoupleAuthIn},
        TContext
      > => {
      return useMutation(getCoupleAuthMeCoupleAuthPostMutationOptions(options), queryClient);
    }
    /**
 * Return the least-privilege picker roster (both partners' names + ids).

The couple-scoped session has selected no one yet, so this exposes ONLY the
display identity needed to choose — never person-bound onboarding answers/consent.
 * @summary Couple Preview
 */
export type couplePreviewMeCouplePreviewGetResponse200 = {
  data: CouplePreviewOut
  status: 200
}

export type couplePreviewMeCouplePreviewGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type couplePreviewMeCouplePreviewGetResponseSuccess = (couplePreviewMeCouplePreviewGetResponse200) & {
  headers: Headers;
};
export type couplePreviewMeCouplePreviewGetResponseError = (couplePreviewMeCouplePreviewGetResponse422) & {
  headers: Headers;
};

export type couplePreviewMeCouplePreviewGetResponse = (couplePreviewMeCouplePreviewGetResponseSuccess | couplePreviewMeCouplePreviewGetResponseError)

export const getCouplePreviewMeCouplePreviewGetUrl = () => {


  

  return `/me/couple/preview`
}

export const couplePreviewMeCouplePreviewGet = async ( options?: RequestInit): Promise<couplePreviewMeCouplePreviewGetResponse> => {
  
  return customInstance<couplePreviewMeCouplePreviewGetResponse>(getCouplePreviewMeCouplePreviewGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getCouplePreviewMeCouplePreviewGetQueryKey = () => {
    return [
    `/me/couple/preview`
    ] as const;
    }

    
export const getCouplePreviewMeCouplePreviewGetQueryOptions = <TData = Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCouplePreviewMeCouplePreviewGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>> = ({ signal }) => couplePreviewMeCouplePreviewGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CouplePreviewMeCouplePreviewGetQueryResult = NonNullable<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>>
export type CouplePreviewMeCouplePreviewGetQueryError = HTTPValidationError


export function useCouplePreviewMeCouplePreviewGet<TData = Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>,
          TError,
          Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCouplePreviewMeCouplePreviewGet<TData = Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>,
          TError,
          Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCouplePreviewMeCouplePreviewGet<TData = Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Couple Preview
 */

export function useCouplePreviewMeCouplePreviewGet<TData = Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof couplePreviewMeCouplePreviewGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCouplePreviewMeCouplePreviewGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Raise a human alert when the opener says neither name on the picker is theirs.

S2 offers the couple's two names and a third option, "Neither of these is me". Taking it
means the link reached the wrong person, or the roster the couple was created with is
wrong. Either way the client is stuck at the door and nothing about it is self-serve, so
the only useful thing this surface can do is tell a human. Before this existed the screen
told them a fresh invite was on its way and no code anywhere sent one.

**Couple-scoped, and the scope IS the authorization.** The subject of the report is the
couple whose token the caller is holding; there is no id in the path or the body to
tamper with, so reporting about somebody else's couple is not a request that can be
expressed. That also matches the only binding a client on this screen actually has: S2 is
pre-bind by construction (the person token is minted by ``select-partner``, which is the
branch NOT taken here).

Discloses nothing: 204, empty body. A caller learns only that the report was accepted,
which they already knew, so the least-privilege line the pre-bind surface draws
(``couple_preview``) is not moved by this.

🔴 **The alert cannot fail this request.** Slack being unset, down, or slow is not the
client's problem, and a diagnostic that can break the screen it reports on is worse than
no diagnostic. The log line above is written FIRST and unconditionally, so the report
survives in CloudWatch even when nothing reaches Slack; the Slack post is the "look at
this now" layer on top of it, not the record.
 * @summary Report Wrong Names
 */
export type reportWrongNamesMeCoupleReportWrongNamesPostResponse204 = {
  data: void
  status: 204
}

export type reportWrongNamesMeCoupleReportWrongNamesPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportWrongNamesMeCoupleReportWrongNamesPostResponseSuccess = (reportWrongNamesMeCoupleReportWrongNamesPostResponse204) & {
  headers: Headers;
};
export type reportWrongNamesMeCoupleReportWrongNamesPostResponseError = (reportWrongNamesMeCoupleReportWrongNamesPostResponse422) & {
  headers: Headers;
};

export type reportWrongNamesMeCoupleReportWrongNamesPostResponse = (reportWrongNamesMeCoupleReportWrongNamesPostResponseSuccess | reportWrongNamesMeCoupleReportWrongNamesPostResponseError)

export const getReportWrongNamesMeCoupleReportWrongNamesPostUrl = () => {


  

  return `/me/couple/report-wrong-names`
}

export const reportWrongNamesMeCoupleReportWrongNamesPost = async ( options?: RequestInit): Promise<reportWrongNamesMeCoupleReportWrongNamesPostResponse> => {
  
  return customInstance<reportWrongNamesMeCoupleReportWrongNamesPostResponse>(getReportWrongNamesMeCoupleReportWrongNamesPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getReportWrongNamesMeCoupleReportWrongNamesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>, TError,void, TContext> => {

const mutationKey = ['reportWrongNamesMeCoupleReportWrongNamesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>, void> = () => {
          

          return  reportWrongNamesMeCoupleReportWrongNamesPost(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReportWrongNamesMeCoupleReportWrongNamesPostMutationResult = NonNullable<Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>>
    
    export type ReportWrongNamesMeCoupleReportWrongNamesPostMutationError = HTTPValidationError

    /**
 * @summary Report Wrong Names
 */
export const useReportWrongNamesMeCoupleReportWrongNamesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportWrongNamesMeCoupleReportWrongNamesPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReportWrongNamesMeCoupleReportWrongNamesPostMutationOptions(options), queryClient);
    }
    /**
 * Resolve the /me-exposed feature flags for the authenticated person.

Returns the safe default (off) for any flag whose row/override is absent
(``default=False``), so the endpoint ships before the flag is seeded.
 * @summary Get Me Feature Flags
 */
export type getMeFeatureFlagsResponse200 = {
  data: MeFeatureFlagsOut
  status: 200
}

export type getMeFeatureFlagsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMeFeatureFlagsResponseSuccess = (getMeFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getMeFeatureFlagsResponseError = (getMeFeatureFlagsResponse422) & {
  headers: Headers;
};

export type getMeFeatureFlagsResponse = (getMeFeatureFlagsResponseSuccess | getMeFeatureFlagsResponseError)

export const getGetMeFeatureFlagsUrl = () => {


  

  return `/me/feature-flags`
}

export const getMeFeatureFlags = async ( options?: RequestInit): Promise<getMeFeatureFlagsResponse> => {
  
  return customInstance<getMeFeatureFlagsResponse>(getGetMeFeatureFlagsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetMeFeatureFlagsQueryKey = () => {
    return [
    `/me/feature-flags`
    ] as const;
    }

    
export const getGetMeFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getMeFeatureFlags>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeFeatureFlagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeFeatureFlags>>> = ({ signal }) => getMeFeatureFlags({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getMeFeatureFlags>>>
export type GetMeFeatureFlagsQueryError = HTTPValidationError


export function useGetMeFeatureFlags<TData = Awaited<ReturnType<typeof getMeFeatureFlags>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getMeFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeFeatureFlags<TData = Awaited<ReturnType<typeof getMeFeatureFlags>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getMeFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeFeatureFlags<TData = Awaited<ReturnType<typeof getMeFeatureFlags>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Me Feature Flags
 */

export function useGetMeFeatureFlags<TData = Awaited<ReturnType<typeof getMeFeatureFlags>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Merge a partial of snake_case answer keys into the partner's form_data.
 * @summary Patch Answers
 */
export type patchAnswersMePartnersPartnerIdAnswersPatchResponse200 = {
  data: PartnerProgressOut
  status: 200
}

export type patchAnswersMePartnersPartnerIdAnswersPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type patchAnswersMePartnersPartnerIdAnswersPatchResponseSuccess = (patchAnswersMePartnersPartnerIdAnswersPatchResponse200) & {
  headers: Headers;
};
export type patchAnswersMePartnersPartnerIdAnswersPatchResponseError = (patchAnswersMePartnersPartnerIdAnswersPatchResponse422) & {
  headers: Headers;
};

export type patchAnswersMePartnersPartnerIdAnswersPatchResponse = (patchAnswersMePartnersPartnerIdAnswersPatchResponseSuccess | patchAnswersMePartnersPartnerIdAnswersPatchResponseError)

export const getPatchAnswersMePartnersPartnerIdAnswersPatchUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/answers`
}

export const patchAnswersMePartnersPartnerIdAnswersPatch = async (partnerId: string,
    answersPatch: AnswersPatch, options?: RequestInit): Promise<patchAnswersMePartnersPartnerIdAnswersPatchResponse> => {
  
  return customInstance<patchAnswersMePartnersPartnerIdAnswersPatchResponse>(getPatchAnswersMePartnersPartnerIdAnswersPatchUrl(partnerId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      answersPatch,)
  }
);}
  



export const getPatchAnswersMePartnersPartnerIdAnswersPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>, TError,{partnerId: string;data: AnswersPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>, TError,{partnerId: string;data: AnswersPatch}, TContext> => {

const mutationKey = ['patchAnswersMePartnersPartnerIdAnswersPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>, {partnerId: string;data: AnswersPatch}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  patchAnswersMePartnersPartnerIdAnswersPatch(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAnswersMePartnersPartnerIdAnswersPatchMutationResult = NonNullable<Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>>
    export type PatchAnswersMePartnersPartnerIdAnswersPatchMutationBody = AnswersPatch
    export type PatchAnswersMePartnersPartnerIdAnswersPatchMutationError = HTTPValidationError

    /**
 * @summary Patch Answers
 */
export const usePatchAnswersMePartnersPartnerIdAnswersPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>, TError,{partnerId: string;data: AnswersPatch}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAnswersMePartnersPartnerIdAnswersPatch>>,
        TError,
        {partnerId: string;data: AnswersPatch},
        TContext
      > => {
      return useMutation(getPatchAnswersMePartnersPartnerIdAnswersPatchMutationOptions(options), queryClient);
    }
    /**
 * Store the rich consent record (3 consents + typed signature) into form_data.

The typed signature must BE the partner's own entered full name — the same rule the
therapist portal enforces (``_require_signature_matches_name``) and the same one the /me S8
signature step already gates on client-side, both now sharing ``utils.names``. Enforcing it
here closes the server-side gap rather than adding user-visible friction: a partner using the
real UI cannot reach a mismatch. Mismatch → 422 carrying the expected name, while the person
is still present to fix the typo (the completion-time transfer, where nobody is watching,
fails safe by skipping the stamp instead).

Unlike the therapist portal this does NOT 409 when no name is on file: /me's confirm-name step
can legitimately be unreached when consent is submitted, and the FE degrades open the same way
— a hard block there would strand the partner with no recourse. The signature is persisted
exactly as typed; only the comparison normalizes.
 * @summary Post Consent
 */
export type postConsentMePartnersPartnerIdConsentPostResponse200 = {
  data: PartnerProgressOut
  status: 200
}

export type postConsentMePartnersPartnerIdConsentPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type postConsentMePartnersPartnerIdConsentPostResponseSuccess = (postConsentMePartnersPartnerIdConsentPostResponse200) & {
  headers: Headers;
};
export type postConsentMePartnersPartnerIdConsentPostResponseError = (postConsentMePartnersPartnerIdConsentPostResponse422) & {
  headers: Headers;
};

export type postConsentMePartnersPartnerIdConsentPostResponse = (postConsentMePartnersPartnerIdConsentPostResponseSuccess | postConsentMePartnersPartnerIdConsentPostResponseError)

export const getPostConsentMePartnersPartnerIdConsentPostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/consent`
}

export const postConsentMePartnersPartnerIdConsentPost = async (partnerId: string,
    consentIn: ConsentIn, options?: RequestInit): Promise<postConsentMePartnersPartnerIdConsentPostResponse> => {
  
  return customInstance<postConsentMePartnersPartnerIdConsentPostResponse>(getPostConsentMePartnersPartnerIdConsentPostUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      consentIn,)
  }
);}
  



export const getPostConsentMePartnersPartnerIdConsentPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>, TError,{partnerId: string;data: ConsentIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>, TError,{partnerId: string;data: ConsentIn}, TContext> => {

const mutationKey = ['postConsentMePartnersPartnerIdConsentPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>, {partnerId: string;data: ConsentIn}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  postConsentMePartnersPartnerIdConsentPost(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostConsentMePartnersPartnerIdConsentPostMutationResult = NonNullable<Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>>
    export type PostConsentMePartnersPartnerIdConsentPostMutationBody = ConsentIn
    export type PostConsentMePartnersPartnerIdConsentPostMutationError = HTTPValidationError

    /**
 * @summary Post Consent
 */
export const usePostConsentMePartnersPartnerIdConsentPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>, TError,{partnerId: string;data: ConsentIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postConsentMePartnersPartnerIdConsentPost>>,
        TError,
        {partnerId: string;data: ConsentIn},
        TContext
      > => {
      return useMutation(getPostConsentMePartnersPartnerIdConsentPostMutationOptions(options), queryClient);
    }
    /**
 * Issue the acting client a consent signer link, then return them to onboarding.

**This endpoint is called TWICE per client now, from two different onboarding steps,
and the gap between them is what the rest of this docstring is about.** Identity
verification happens early (right after the identity step, natively inside ``/me``);
the document and the signature stay at the end. Both phases address the envelope by
its link token, and the token exists in plaintext exactly once — here, in the
response. Only its hash is stored (``esign/envelope.py``), so it cannot be reissued
or looked up afterwards.

The client therefore holds the token between the two steps, and the failure that
matters is the client LOSING it. Nothing in the request distinguishes that client
from a first-time signer: both arrive with no token and a legitimate need for one. So
the naive endpoint mints a second envelope, the client is asked for a second one-time
code, the early verification bought nothing, and **no part of that is an error** —
not to the server, not to the trail, and not to the signer, who assumes two codes is
just how it works.

``pending_envelope_status`` is what makes it visible, and it changes the contract:

* The caller is carrying a token this server confirms belongs to THIS run ⇒ **mint
  nothing** and report ``carried_token_status``. The client already holds a usable
  envelope, and handing it a second one strands the code the first one emailed. This
  is checked first because it is the most specific thing known about the caller, and
  because the two coarser answers below are both wrong while an unverified replacement
  is outstanding.
* A pending verified envelope exists and the caller did not ask for a new one ⇒
  **mint nothing** and report ``pending_status``. The caller is expected to use the
  token it already holds. If it holds none, it now knows to say so rather than to
  discover a second code in the client's mailbox.
* The caller sets ``force_new`` ⇒ mint, and record
  ``EsignEvent.LINK_CONTINUITY_BROKEN`` against the new envelope. That is the whole
  point of the flag: re-verification is a legitimate recovery and must remain
  available, but it must leave a mark, because a recovery nobody can count is
  indistinguishable from a flow that works.

Minting a second envelope is legal — a signer may hold many over time, which is what
the IDV-6 trigger is deliberately written to permit (see ``EsignEnvelope``) — so
nothing here fails closed. The cost is a wasted verification, and the remedy is that
it is reportable.
 * @summary Create Consent Envelope
 */
export type createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse200 = {
  data: ConsentEnvelopeOut
  status: 200
}

export type createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponseSuccess = (createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse200) & {
  headers: Headers;
};
export type createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponseError = (createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse422) & {
  headers: Headers;
};

export type createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse = (createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponseSuccess | createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponseError)

export const getCreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/consent-envelope`
}

export const createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost = async (partnerId: string,
    consentEnvelopeInNull: ConsentEnvelopeIn | null, options?: RequestInit): Promise<createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse> => {
  
  return customInstance<createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostResponse>(getCreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      consentEnvelopeInNull,)
  }
);}
  



export const getCreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>, TError,{partnerId: string;data: ConsentEnvelopeIn | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>, TError,{partnerId: string;data: ConsentEnvelopeIn | null}, TContext> => {

const mutationKey = ['createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>, {partnerId: string;data: ConsentEnvelopeIn | null}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostMutationResult = NonNullable<Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>>
    export type CreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostMutationBody = ConsentEnvelopeIn | null
    export type CreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostMutationError = HTTPValidationError

    /**
 * @summary Create Consent Envelope
 */
export const useCreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>, TError,{partnerId: string;data: ConsentEnvelopeIn | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConsentEnvelopeMePartnersPartnerIdConsentEnvelopePost>>,
        TError,
        {partnerId: string;data: ConsentEnvelopeIn | null},
        TContext
      > => {
      return useMutation(getCreateConsentEnvelopeMePartnersPartnerIdConsentEnvelopePostMutationOptions(options), queryClient);
    }
    /**
 * Persist the acting partner's client-entered email and/or phone as PersonContacts.

Both fields are optional — submitting neither is a valid no-op (the step is
skippable). The phone is normalized to E.164 and stored under the messaging
provider (matching ``create_couple``); the email is its own ``provider='email'``
channel (D4). This is SUPPLEMENTARY reachability only and is deliberately NOT
wired into inbound matching / identity — the per-person invite code owns that.
Authz: a partner may only write their OWN contact (cross-partner is 403).
 * @summary Post Contact
 */
export type postContactMePartnersPartnerIdContactPostResponse200 = {
  data: ContactOut
  status: 200
}

export type postContactMePartnersPartnerIdContactPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type postContactMePartnersPartnerIdContactPostResponseSuccess = (postContactMePartnersPartnerIdContactPostResponse200) & {
  headers: Headers;
};
export type postContactMePartnersPartnerIdContactPostResponseError = (postContactMePartnersPartnerIdContactPostResponse422) & {
  headers: Headers;
};

export type postContactMePartnersPartnerIdContactPostResponse = (postContactMePartnersPartnerIdContactPostResponseSuccess | postContactMePartnersPartnerIdContactPostResponseError)

export const getPostContactMePartnersPartnerIdContactPostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/contact`
}

export const postContactMePartnersPartnerIdContactPost = async (partnerId: string,
    contactIn: ContactIn, options?: RequestInit): Promise<postContactMePartnersPartnerIdContactPostResponse> => {
  
  return customInstance<postContactMePartnersPartnerIdContactPostResponse>(getPostContactMePartnersPartnerIdContactPostUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contactIn,)
  }
);}
  



export const getPostContactMePartnersPartnerIdContactPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>, TError,{partnerId: string;data: ContactIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>, TError,{partnerId: string;data: ContactIn}, TContext> => {

const mutationKey = ['postContactMePartnersPartnerIdContactPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>, {partnerId: string;data: ContactIn}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  postContactMePartnersPartnerIdContactPost(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactMePartnersPartnerIdContactPostMutationResult = NonNullable<Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>>
    export type PostContactMePartnersPartnerIdContactPostMutationBody = ContactIn
    export type PostContactMePartnersPartnerIdContactPostMutationError = HTTPValidationError

    /**
 * @summary Post Contact
 */
export const usePostContactMePartnersPartnerIdContactPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>, TError,{partnerId: string;data: ContactIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContactMePartnersPartnerIdContactPost>>,
        TError,
        {partnerId: string;data: ContactIn},
        TContext
      > => {
      return useMutation(getPostContactMePartnersPartnerIdContactPostMutationOptions(options), queryClient);
    }
    /**
 * Therapist-facing flag: the acting partner reports they have no email on file.

Idempotent — records ``email_missing_flagged`` on the partner's form_data. If an
email contact already exists, no flag is set and ``has_email`` is True.
 * @summary Flag Missing Email
 */
export type flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse200 = {
  data: FlagMissingEmailOut
  status: 200
}

export type flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponseSuccess = (flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse200) & {
  headers: Headers;
};
export type flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponseError = (flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse422) & {
  headers: Headers;
};

export type flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse = (flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponseSuccess | flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponseError)

export const getFlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/flag-missing-email`
}

export const flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost = async (partnerId: string, options?: RequestInit): Promise<flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse> => {
  
  return customInstance<flagMissingEmailMePartnersPartnerIdFlagMissingEmailPostResponse>(getFlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostUrl(partnerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getFlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>, TError,{partnerId: string}, TContext> => {

const mutationKey = ['flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>, {partnerId: string}> = (props) => {
          const {partnerId} = props ?? {};

          return  flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost(partnerId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type FlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostMutationResult = NonNullable<Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>>
    
    export type FlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostMutationError = HTTPValidationError

    /**
 * @summary Flag Missing Email
 */
export const useFlagMissingEmailMePartnersPartnerIdFlagMissingEmailPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof flagMissingEmailMePartnersPartnerIdFlagMissingEmailPost>>,
        TError,
        {partnerId: string},
        TContext
      > => {
      return useMutation(getFlagMissingEmailMePartnersPartnerIdFlagMissingEmailPostMutationOptions(options), queryClient);
    }
    /**
 * Return the ACTING partner's per-person access code + a Linq deep link (idempotent).

Each partner gets their OWN per-person ``access_code`` — texting ``DOVA-<code>`` binds
the sender directly to THAT partner (no phone guessing). Falls back to the couple-level
code for legacy couples created before per-person minting (their participant rows have
no per-person code). The deep link targets the configured Linq therapist handle
(``LINQ_THERAPIST_HANDLES``), not a hardcoded number.
 * @summary Sms Handoff
 */
export type smsHandoffMePartnersPartnerIdSmsHandoffPostResponse200 = {
  data: SmsHandoffOut
  status: 200
}

export type smsHandoffMePartnersPartnerIdSmsHandoffPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type smsHandoffMePartnersPartnerIdSmsHandoffPostResponseSuccess = (smsHandoffMePartnersPartnerIdSmsHandoffPostResponse200) & {
  headers: Headers;
};
export type smsHandoffMePartnersPartnerIdSmsHandoffPostResponseError = (smsHandoffMePartnersPartnerIdSmsHandoffPostResponse422) & {
  headers: Headers;
};

export type smsHandoffMePartnersPartnerIdSmsHandoffPostResponse = (smsHandoffMePartnersPartnerIdSmsHandoffPostResponseSuccess | smsHandoffMePartnersPartnerIdSmsHandoffPostResponseError)

export const getSmsHandoffMePartnersPartnerIdSmsHandoffPostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/sms-handoff`
}

export const smsHandoffMePartnersPartnerIdSmsHandoffPost = async (partnerId: string, options?: RequestInit): Promise<smsHandoffMePartnersPartnerIdSmsHandoffPostResponse> => {
  
  return customInstance<smsHandoffMePartnersPartnerIdSmsHandoffPostResponse>(getSmsHandoffMePartnersPartnerIdSmsHandoffPostUrl(partnerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getSmsHandoffMePartnersPartnerIdSmsHandoffPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>, TError,{partnerId: string}, TContext> => {

const mutationKey = ['smsHandoffMePartnersPartnerIdSmsHandoffPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>, {partnerId: string}> = (props) => {
          const {partnerId} = props ?? {};

          return  smsHandoffMePartnersPartnerIdSmsHandoffPost(partnerId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SmsHandoffMePartnersPartnerIdSmsHandoffPostMutationResult = NonNullable<Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>>
    
    export type SmsHandoffMePartnersPartnerIdSmsHandoffPostMutationError = HTTPValidationError

    /**
 * @summary Sms Handoff
 */
export const useSmsHandoffMePartnersPartnerIdSmsHandoffPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof smsHandoffMePartnersPartnerIdSmsHandoffPost>>,
        TError,
        {partnerId: string},
        TContext
      > => {
      return useMutation(getSmsHandoffMePartnersPartnerIdSmsHandoffPostMutationOptions(options), queryClient);
    }
    /**
 * Persist the partner's browser-detected IANA timezone for session localization.

This is the BE capture path WP-G provides (the FE capture UI is a separate
workstream): the scheduling read path
(``services.scheduling_timezone.resolve_client_timezone``) reads this stored tz so
sessions render in the CLIENT's timezone, not the viewer's browser tz. It is stored
on the person's 1:1 conversation via the existing ``update_latest_timezone`` field —
the same canonical store the daily-question / v1-onboarding paths already feed, so a
couple onboarded purely via ``/me`` gets one durable client-tz value.

Authz: a partner may only write their OWN timezone (cross-partner is 403). An invalid
IANA string is rejected (422) rather than silently dropped — letting a bad value
through would wipe a previously-stored good tz (the ``ConversationData`` validator
sanitizes invalid → None on write).
 * @summary Patch Timezone
 */
export type patchTimezoneMePartnersPartnerIdTimezonePatchResponse200 = {
  data: TimezoneOut
  status: 200
}

export type patchTimezoneMePartnersPartnerIdTimezonePatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type patchTimezoneMePartnersPartnerIdTimezonePatchResponseSuccess = (patchTimezoneMePartnersPartnerIdTimezonePatchResponse200) & {
  headers: Headers;
};
export type patchTimezoneMePartnersPartnerIdTimezonePatchResponseError = (patchTimezoneMePartnersPartnerIdTimezonePatchResponse422) & {
  headers: Headers;
};

export type patchTimezoneMePartnersPartnerIdTimezonePatchResponse = (patchTimezoneMePartnersPartnerIdTimezonePatchResponseSuccess | patchTimezoneMePartnersPartnerIdTimezonePatchResponseError)

export const getPatchTimezoneMePartnersPartnerIdTimezonePatchUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/timezone`
}

export const patchTimezoneMePartnersPartnerIdTimezonePatch = async (partnerId: string,
    timezoneIn: TimezoneIn, options?: RequestInit): Promise<patchTimezoneMePartnersPartnerIdTimezonePatchResponse> => {
  
  return customInstance<patchTimezoneMePartnersPartnerIdTimezonePatchResponse>(getPatchTimezoneMePartnersPartnerIdTimezonePatchUrl(partnerId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      timezoneIn,)
  }
);}
  



export const getPatchTimezoneMePartnersPartnerIdTimezonePatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>, TError,{partnerId: string;data: TimezoneIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>, TError,{partnerId: string;data: TimezoneIn}, TContext> => {

const mutationKey = ['patchTimezoneMePartnersPartnerIdTimezonePatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>, {partnerId: string;data: TimezoneIn}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  patchTimezoneMePartnersPartnerIdTimezonePatch(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTimezoneMePartnersPartnerIdTimezonePatchMutationResult = NonNullable<Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>>
    export type PatchTimezoneMePartnersPartnerIdTimezonePatchMutationBody = TimezoneIn
    export type PatchTimezoneMePartnersPartnerIdTimezonePatchMutationError = HTTPValidationError

    /**
 * @summary Patch Timezone
 */
export const usePatchTimezoneMePartnersPartnerIdTimezonePatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>, TError,{partnerId: string;data: TimezoneIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTimezoneMePartnersPartnerIdTimezonePatch>>,
        TError,
        {partnerId: string;data: TimezoneIn},
        TContext
      > => {
      return useMutation(getPatchTimezoneMePartnersPartnerIdTimezonePatchMutationOptions(options), queryClient);
    }
    /**
 * Record that the early-verification step gave up, so the giving-up can be counted.

**The step this reports on is designed never to block.** Any failure it meets — no
email on file, a legacy couple with no client group, the IDV-6 guard rejecting a
shared address — drops the client through to verifying at the end of onboarding, which
is where it happened before this optimisation existed. That is the correct behaviour
and it is why nothing about it is an error.

It is also why it needs recording. A degradation that only ever shows as the ABSENCE
of a thing — no early verification, no second envelope, no complaint — is invisible
exactly when it matters most: a change that breaks the optimisation for everyone looks
identical to the optimisation quietly working. A count of zero cannot distinguish
"never happens" from "the instrument stopped reporting". So the skip is written down
at the moment it is decided, by the only party that knows it was decided.

A server log rather than an esign audit event, deliberately: nothing legal happened.
No envelope was created, no identity was proven, and there may be no envelope to
attach a row to. Putting a non-event in the consent trail would dilute a record whose
value is that everything in it is evidence.

**No token, no email, no error object.** The cause is one of three constants and the
status code is an integer; both are useful to an operator and neither identifies
anybody. ``person_id`` is the database id, which is what the rest of this surface logs.
 * @summary Report Verification Skipped
 */
export type reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse204 = {
  data: void
  status: 204
}

export type reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponseSuccess = (reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse204) & {
  headers: Headers;
};
export type reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponseError = (reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse422) & {
  headers: Headers;
};

export type reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse = (reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponseSuccess | reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponseError)

export const getReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostUrl = (partnerId: string,) => {


  

  return `/me/partners/${partnerId}/verification-skipped`
}

export const reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost = async (partnerId: string,
    verificationSkipIn: VerificationSkipIn, options?: RequestInit): Promise<reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse> => {
  
  return customInstance<reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostResponse>(getReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verificationSkipIn,)
  }
);}
  



export const getReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>, TError,{partnerId: string;data: VerificationSkipIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>, TError,{partnerId: string;data: VerificationSkipIn}, TContext> => {

const mutationKey = ['reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>, {partnerId: string;data: VerificationSkipIn}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost(partnerId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostMutationResult = NonNullable<Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>>
    export type ReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostMutationBody = VerificationSkipIn
    export type ReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostMutationError = HTTPValidationError

    /**
 * @summary Report Verification Skipped
 */
export const useReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>, TError,{partnerId: string;data: VerificationSkipIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportVerificationSkippedMePartnersPartnerIdVerificationSkippedPost>>,
        TError,
        {partnerId: string;data: VerificationSkipIn},
        TContext
      > => {
      return useMutation(getReportVerificationSkippedMePartnersPartnerIdVerificationSkippedPostMutationOptions(options), queryClient);
    }
    /**
 * @summary List Reports
 */
export type listReportsResponse200 = {
  data: ReportsOut
  status: 200
}

export type listReportsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listReportsResponseSuccess = (listReportsResponse200) & {
  headers: Headers;
};
export type listReportsResponseError = (listReportsResponse422) & {
  headers: Headers;
};

export type listReportsResponse = (listReportsResponseSuccess | listReportsResponseError)

export const getListReportsUrl = (params?: ListReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/me/reports?${stringifiedParams}` : `/me/reports`
}

export const listReports = async (params?: ListReportsParams, options?: RequestInit): Promise<listReportsResponse> => {
  
  return customInstance<listReportsResponse>(getListReportsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListReportsQueryKey = (params?: ListReportsParams,) => {
    return [
    `/me/reports`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListReportsQueryOptions = <TData = Awaited<ReturnType<typeof listReports>>, TError = HTTPValidationError>(params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReports>>> = ({ signal }) => listReports(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listReports>>>
export type ListReportsQueryError = HTTPValidationError


export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = HTTPValidationError>(
 params: undefined |  ListReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = HTTPValidationError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = HTTPValidationError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Reports
 */

export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = HTTPValidationError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get Report
 */
export type getReportResponse200 = {
  data: ReportOut
  status: 200
}

export type getReportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getReportResponseSuccess = (getReportResponse200) & {
  headers: Headers;
};
export type getReportResponseError = (getReportResponse422) & {
  headers: Headers;
};

export type getReportResponse = (getReportResponseSuccess | getReportResponseError)

export const getGetReportUrl = (reportUuid: string,) => {


  

  return `/me/reports/${reportUuid}`
}

export const getReport = async (reportUuid: string, options?: RequestInit): Promise<getReportResponse> => {
  
  return customInstance<getReportResponse>(getGetReportUrl(reportUuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetReportQueryKey = (reportUuid: string,) => {
    return [
    `/me/reports/${reportUuid}`
    ] as const;
    }

    
export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(reportUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) => getReport(reportUuid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>
export type GetReportQueryError = HTTPValidationError


export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Report
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 reportUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportQueryOptions(reportUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Mark Report Viewed
 */
export type markReportViewedResponse200 = {
  data: ReportViewedOut
  status: 200
}

export type markReportViewedResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type markReportViewedResponseSuccess = (markReportViewedResponse200) & {
  headers: Headers;
};
export type markReportViewedResponseError = (markReportViewedResponse422) & {
  headers: Headers;
};

export type markReportViewedResponse = (markReportViewedResponseSuccess | markReportViewedResponseError)

export const getMarkReportViewedUrl = (reportUuid: string,) => {


  

  return `/me/reports/${reportUuid}/viewed`
}

export const markReportViewed = async (reportUuid: string, options?: RequestInit): Promise<markReportViewedResponse> => {
  
  return customInstance<markReportViewedResponse>(getMarkReportViewedUrl(reportUuid),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getMarkReportViewedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReportViewed>>, TError,{reportUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markReportViewed>>, TError,{reportUuid: string}, TContext> => {

const mutationKey = ['markReportViewed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markReportViewed>>, {reportUuid: string}> = (props) => {
          const {reportUuid} = props ?? {};

          return  markReportViewed(reportUuid,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MarkReportViewedMutationResult = NonNullable<Awaited<ReturnType<typeof markReportViewed>>>
    
    export type MarkReportViewedMutationError = HTTPValidationError

    /**
 * @summary Mark Report Viewed
 */
export const useMarkReportViewed = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markReportViewed>>, TError,{reportUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markReportViewed>>,
        TError,
        {reportUuid: string},
        TContext
      > => {
      return useMutation(getMarkReportViewedMutationOptions(options), queryClient);
    }
    /**
 * The signed-in person's actionable pending offers for the Homebase CTA — no deeplink needed.

DB-only: reads the offer rows + their ``candidates`` JSONB directly (no Redis / no
``CandidateSetStore``). Returns picker offers they must respond to and initiator offers awaiting
the partner or needing a re-offer, soonest deadline first.
 * @summary List Reschedule Offers
 */
export type listRescheduleOffersMeRescheduleOffersGetResponse200 = {
  data: ActionableRescheduleOfferOut[]
  status: 200
}

export type listRescheduleOffersMeRescheduleOffersGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listRescheduleOffersMeRescheduleOffersGetResponseSuccess = (listRescheduleOffersMeRescheduleOffersGetResponse200) & {
  headers: Headers;
};
export type listRescheduleOffersMeRescheduleOffersGetResponseError = (listRescheduleOffersMeRescheduleOffersGetResponse422) & {
  headers: Headers;
};

export type listRescheduleOffersMeRescheduleOffersGetResponse = (listRescheduleOffersMeRescheduleOffersGetResponseSuccess | listRescheduleOffersMeRescheduleOffersGetResponseError)

export const getListRescheduleOffersMeRescheduleOffersGetUrl = () => {


  

  return `/me/reschedule-offers`
}

export const listRescheduleOffersMeRescheduleOffersGet = async ( options?: RequestInit): Promise<listRescheduleOffersMeRescheduleOffersGetResponse> => {
  
  return customInstance<listRescheduleOffersMeRescheduleOffersGetResponse>(getListRescheduleOffersMeRescheduleOffersGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListRescheduleOffersMeRescheduleOffersGetQueryKey = () => {
    return [
    `/me/reschedule-offers`
    ] as const;
    }

    
export const getListRescheduleOffersMeRescheduleOffersGetQueryOptions = <TData = Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRescheduleOffersMeRescheduleOffersGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>> = ({ signal }) => listRescheduleOffersMeRescheduleOffersGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRescheduleOffersMeRescheduleOffersGetQueryResult = NonNullable<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>>
export type ListRescheduleOffersMeRescheduleOffersGetQueryError = HTTPValidationError


export function useListRescheduleOffersMeRescheduleOffersGet<TData = Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>,
          TError,
          Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRescheduleOffersMeRescheduleOffersGet<TData = Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>,
          TError,
          Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRescheduleOffersMeRescheduleOffersGet<TData = Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Reschedule Offers
 */

export function useListRescheduleOffersMeRescheduleOffersGet<TData = Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRescheduleOffersMeRescheduleOffersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRescheduleOffersMeRescheduleOffersGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Return only A's selected choices to the authenticated designated picker B.
 * @summary Get Reschedule Offer
 */
export type getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse200 = {
  data: RescheduleOfferOut
  status: 200
}

export type getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getRescheduleOfferMeRescheduleOffersOfferUuidGetResponseSuccess = (getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse200) & {
  headers: Headers;
};
export type getRescheduleOfferMeRescheduleOffersOfferUuidGetResponseError = (getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse422) & {
  headers: Headers;
};

export type getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse = (getRescheduleOfferMeRescheduleOffersOfferUuidGetResponseSuccess | getRescheduleOfferMeRescheduleOffersOfferUuidGetResponseError)

export const getGetRescheduleOfferMeRescheduleOffersOfferUuidGetUrl = (offerUuid: string,) => {


  

  return `/me/reschedule-offers/${offerUuid}`
}

export const getRescheduleOfferMeRescheduleOffersOfferUuidGet = async (offerUuid: string, options?: RequestInit): Promise<getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse> => {
  
  return customInstance<getRescheduleOfferMeRescheduleOffersOfferUuidGetResponse>(getGetRescheduleOfferMeRescheduleOffersOfferUuidGetUrl(offerUuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryKey = (offerUuid: string,) => {
    return [
    `/me/reschedule-offers/${offerUuid}`
    ] as const;
    }

    
export const getGetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryOptions = <TData = Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError = HTTPValidationError>(offerUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryKey(offerUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>> = ({ signal }) => getRescheduleOfferMeRescheduleOffersOfferUuidGet(offerUuid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(offerUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>>
export type GetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryError = HTTPValidationError


export function useGetRescheduleOfferMeRescheduleOffersOfferUuidGet<TData = Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError = HTTPValidationError>(
 offerUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>,
          TError,
          Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRescheduleOfferMeRescheduleOffersOfferUuidGet<TData = Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError = HTTPValidationError>(
 offerUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>,
          TError,
          Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRescheduleOfferMeRescheduleOffersOfferUuidGet<TData = Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError = HTTPValidationError>(
 offerUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Reschedule Offer
 */

export function useGetRescheduleOfferMeRescheduleOffersOfferUuidGet<TData = Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError = HTTPValidationError>(
 offerUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRescheduleOfferMeRescheduleOffersOfferUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRescheduleOfferMeRescheduleOffersOfferUuidGetQueryOptions(offerUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Revalidate B's selected candidate and perform the one same-row durable move.
 * @summary Accept Reschedule Offer
 */
export type acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse200 = {
  data: RescheduleOfferMutationOut
  status: 200
}

export type acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponseSuccess = (acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse200) & {
  headers: Headers;
};
export type acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponseError = (acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse422) & {
  headers: Headers;
};

export type acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse = (acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponseSuccess | acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponseError)

export const getAcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostUrl = (offerUuid: string,) => {


  

  return `/me/reschedule-offers/${offerUuid}/accept`
}

export const acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost = async (offerUuid: string,
    rescheduleOfferPickIn: RescheduleOfferPickIn, options?: RequestInit): Promise<acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse> => {
  
  return customInstance<acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostResponse>(getAcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostUrl(offerUuid),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rescheduleOfferPickIn,)
  }
);}
  



export const getAcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>, TError,{offerUuid: string;data: RescheduleOfferPickIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>, TError,{offerUuid: string;data: RescheduleOfferPickIn}, TContext> => {

const mutationKey = ['acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>, {offerUuid: string;data: RescheduleOfferPickIn}> = (props) => {
          const {offerUuid,data} = props ?? {};

          return  acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost(offerUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostMutationResult = NonNullable<Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>>
    export type AcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostMutationBody = RescheduleOfferPickIn
    export type AcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostMutationError = HTTPValidationError

    /**
 * @summary Accept Reschedule Offer
 */
export const useAcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>, TError,{offerUuid: string;data: RescheduleOfferPickIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPost>>,
        TError,
        {offerUuid: string;data: RescheduleOfferPickIn},
        TContext
      > => {
      return useMutation(getAcceptRescheduleOfferMeRescheduleOffersOfferUuidAcceptPostMutationOptions(options), queryClient);
    }
    /**
 * Record B's decline and cancel the already released session.
 * @summary Decline Reschedule Offer
 */
export type declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse200 = {
  data: RescheduleOfferMutationOut
  status: 200
}

export type declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponseSuccess = (declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse200) & {
  headers: Headers;
};
export type declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponseError = (declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse422) & {
  headers: Headers;
};

export type declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse = (declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponseSuccess | declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponseError)

export const getDeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostUrl = (offerUuid: string,) => {


  

  return `/me/reschedule-offers/${offerUuid}/decline`
}

export const declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost = async (offerUuid: string,
    rescheduleOfferDeclineIn: RescheduleOfferDeclineIn, options?: RequestInit): Promise<declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse> => {
  
  return customInstance<declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostResponse>(getDeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostUrl(offerUuid),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rescheduleOfferDeclineIn,)
  }
);}
  



export const getDeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>, TError,{offerUuid: string;data: RescheduleOfferDeclineIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>, TError,{offerUuid: string;data: RescheduleOfferDeclineIn}, TContext> => {

const mutationKey = ['declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>, {offerUuid: string;data: RescheduleOfferDeclineIn}> = (props) => {
          const {offerUuid,data} = props ?? {};

          return  declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost(offerUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostMutationResult = NonNullable<Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>>
    export type DeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostMutationBody = RescheduleOfferDeclineIn
    export type DeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostMutationError = HTTPValidationError

    /**
 * @summary Decline Reschedule Offer
 */
export const useDeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>, TError,{offerUuid: string;data: RescheduleOfferDeclineIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePost>>,
        TError,
        {offerUuid: string;data: RescheduleOfferDeclineIn},
        TContext
      > => {
      return useMutation(getDeclineRescheduleOfferMeRescheduleOffersOfferUuidDeclinePostMutationOptions(options), queryClient);
    }
    /**
 * Self-select a partner and mint the person-bound token (DIRECT bind).

``partner_id`` (person_global_uuid) MUST be a member of THIS couple — selecting a
non-member is a 404 (basic correctness, not the dropped impersonation gate). The
optional ``secret`` is routed through ``validate_partner_secret`` (today always
passes) so a future PIN can gate the bind without re-architecting.
 * @summary Select Partner
 */
export type selectPartnerMeSelectPartnerPostResponse200 = {
  data: SelectPartnerOut
  status: 200
}

export type selectPartnerMeSelectPartnerPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type selectPartnerMeSelectPartnerPostResponseSuccess = (selectPartnerMeSelectPartnerPostResponse200) & {
  headers: Headers;
};
export type selectPartnerMeSelectPartnerPostResponseError = (selectPartnerMeSelectPartnerPostResponse422) & {
  headers: Headers;
};

export type selectPartnerMeSelectPartnerPostResponse = (selectPartnerMeSelectPartnerPostResponseSuccess | selectPartnerMeSelectPartnerPostResponseError)

export const getSelectPartnerMeSelectPartnerPostUrl = () => {


  

  return `/me/select-partner`
}

export const selectPartnerMeSelectPartnerPost = async (selectPartnerIn: SelectPartnerIn, options?: RequestInit): Promise<selectPartnerMeSelectPartnerPostResponse> => {
  
  return customInstance<selectPartnerMeSelectPartnerPostResponse>(getSelectPartnerMeSelectPartnerPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      selectPartnerIn,)
  }
);}
  



export const getSelectPartnerMeSelectPartnerPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>, TError,{data: SelectPartnerIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>, TError,{data: SelectPartnerIn}, TContext> => {

const mutationKey = ['selectPartnerMeSelectPartnerPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>, {data: SelectPartnerIn}> = (props) => {
          const {data} = props ?? {};

          return  selectPartnerMeSelectPartnerPost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SelectPartnerMeSelectPartnerPostMutationResult = NonNullable<Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>>
    export type SelectPartnerMeSelectPartnerPostMutationBody = SelectPartnerIn
    export type SelectPartnerMeSelectPartnerPostMutationError = HTTPValidationError

    /**
 * @summary Select Partner
 */
export const useSelectPartnerMeSelectPartnerPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>, TError,{data: SelectPartnerIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selectPartnerMeSelectPartnerPost>>,
        TError,
        {data: SelectPartnerIn},
        TContext
      > => {
      return useMutation(getSelectPartnerMeSelectPartnerPostMutationOptions(options), queryClient);
    }
    /**
 * Exchange a short-TTL person-link token for the durable person session JWT.

Auth = NONE by design: the opaque token IS the credential (it arrives in a
personal-login-link §5.6 or a per-recipient session-deeplink). On redeem we verify
the token against Redis → resolve a ``person_id`` + scope (never a couple) → mint
``create_jwt_token(person_id)``. The homebase SPA stores the returned token in
localStorage as the durable person session.

Replay-tolerant within TTL (the token is not consumed) so SMS/iMessage link
previews and SPA retries don't strand the user; a single-use posture is an opt-in
seam on ``verify_person_link_token(consume=True)``.
 * @summary Redeem Session Token
 */
export type redeemSessionTokenMeSessionTokenRedeemPostResponse200 = {
  data: SessionTokenRedeemOut
  status: 200
}

export type redeemSessionTokenMeSessionTokenRedeemPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type redeemSessionTokenMeSessionTokenRedeemPostResponseSuccess = (redeemSessionTokenMeSessionTokenRedeemPostResponse200) & {
  headers: Headers;
};
export type redeemSessionTokenMeSessionTokenRedeemPostResponseError = (redeemSessionTokenMeSessionTokenRedeemPostResponse422) & {
  headers: Headers;
};

export type redeemSessionTokenMeSessionTokenRedeemPostResponse = (redeemSessionTokenMeSessionTokenRedeemPostResponseSuccess | redeemSessionTokenMeSessionTokenRedeemPostResponseError)

export const getRedeemSessionTokenMeSessionTokenRedeemPostUrl = () => {


  

  return `/me/session-token/redeem`
}

export const redeemSessionTokenMeSessionTokenRedeemPost = async (sessionTokenRedeemIn: SessionTokenRedeemIn, options?: RequestInit): Promise<redeemSessionTokenMeSessionTokenRedeemPostResponse> => {
  
  return customInstance<redeemSessionTokenMeSessionTokenRedeemPostResponse>(getRedeemSessionTokenMeSessionTokenRedeemPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionTokenRedeemIn,)
  }
);}
  



export const getRedeemSessionTokenMeSessionTokenRedeemPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>, TError,{data: SessionTokenRedeemIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>, TError,{data: SessionTokenRedeemIn}, TContext> => {

const mutationKey = ['redeemSessionTokenMeSessionTokenRedeemPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>, {data: SessionTokenRedeemIn}> = (props) => {
          const {data} = props ?? {};

          return  redeemSessionTokenMeSessionTokenRedeemPost(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RedeemSessionTokenMeSessionTokenRedeemPostMutationResult = NonNullable<Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>>
    export type RedeemSessionTokenMeSessionTokenRedeemPostMutationBody = SessionTokenRedeemIn
    export type RedeemSessionTokenMeSessionTokenRedeemPostMutationError = HTTPValidationError

    /**
 * @summary Redeem Session Token
 */
export const useRedeemSessionTokenMeSessionTokenRedeemPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>, TError,{data: SessionTokenRedeemIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemSessionTokenMeSessionTokenRedeemPost>>,
        TError,
        {data: SessionTokenRedeemIn},
        TContext
      > => {
      return useMutation(getRedeemSessionTokenMeSessionTokenRedeemPostMutationOptions(options), queryClient);
    }
    /**
 * The signed-in person's delivered past sessions, newest first, with cursor pagination.
 * @summary List Past Sessions
 */
export type listPastSessionsMeSessionsPastGetResponse200 = {
  data: PastSessionsOut
  status: 200
}

export type listPastSessionsMeSessionsPastGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPastSessionsMeSessionsPastGetResponseSuccess = (listPastSessionsMeSessionsPastGetResponse200) & {
  headers: Headers;
};
export type listPastSessionsMeSessionsPastGetResponseError = (listPastSessionsMeSessionsPastGetResponse422) & {
  headers: Headers;
};

export type listPastSessionsMeSessionsPastGetResponse = (listPastSessionsMeSessionsPastGetResponseSuccess | listPastSessionsMeSessionsPastGetResponseError)

export const getListPastSessionsMeSessionsPastGetUrl = (params?: ListPastSessionsMeSessionsPastGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/me/sessions/past?${stringifiedParams}` : `/me/sessions/past`
}

export const listPastSessionsMeSessionsPastGet = async (params?: ListPastSessionsMeSessionsPastGetParams, options?: RequestInit): Promise<listPastSessionsMeSessionsPastGetResponse> => {
  
  return customInstance<listPastSessionsMeSessionsPastGetResponse>(getListPastSessionsMeSessionsPastGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListPastSessionsMeSessionsPastGetQueryKey = (params?: ListPastSessionsMeSessionsPastGetParams,) => {
    return [
    `/me/sessions/past`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListPastSessionsMeSessionsPastGetQueryOptions = <TData = Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError = HTTPValidationError>(params?: ListPastSessionsMeSessionsPastGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPastSessionsMeSessionsPastGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>> = ({ signal }) => listPastSessionsMeSessionsPastGet(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPastSessionsMeSessionsPastGetQueryResult = NonNullable<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>>
export type ListPastSessionsMeSessionsPastGetQueryError = HTTPValidationError


export function useListPastSessionsMeSessionsPastGet<TData = Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError = HTTPValidationError>(
 params: undefined |  ListPastSessionsMeSessionsPastGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>,
          TError,
          Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPastSessionsMeSessionsPastGet<TData = Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError = HTTPValidationError>(
 params?: ListPastSessionsMeSessionsPastGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>,
          TError,
          Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPastSessionsMeSessionsPastGet<TData = Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError = HTTPValidationError>(
 params?: ListPastSessionsMeSessionsPastGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Past Sessions
 */

export function useListPastSessionsMeSessionsPastGet<TData = Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError = HTTPValidationError>(
 params?: ListPastSessionsMeSessionsPastGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastSessionsMeSessionsPastGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPastSessionsMeSessionsPastGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * The signed-in person's couple's upcoming sessions, localized to the client's stored tz.

A couple with no ``ClientGroup`` yet (legacy, never scheduled) simply has no sessions —
returns an empty list rather than erroring.
 * @summary List Upcoming Sessions
 */
export type listUpcomingSessionsMeSessionsUpcomingGetResponse200 = {
  data: CoachedSessionOut[]
  status: 200
}

export type listUpcomingSessionsMeSessionsUpcomingGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listUpcomingSessionsMeSessionsUpcomingGetResponseSuccess = (listUpcomingSessionsMeSessionsUpcomingGetResponse200) & {
  headers: Headers;
};
export type listUpcomingSessionsMeSessionsUpcomingGetResponseError = (listUpcomingSessionsMeSessionsUpcomingGetResponse422) & {
  headers: Headers;
};

export type listUpcomingSessionsMeSessionsUpcomingGetResponse = (listUpcomingSessionsMeSessionsUpcomingGetResponseSuccess | listUpcomingSessionsMeSessionsUpcomingGetResponseError)

export const getListUpcomingSessionsMeSessionsUpcomingGetUrl = () => {


  

  return `/me/sessions/upcoming`
}

export const listUpcomingSessionsMeSessionsUpcomingGet = async ( options?: RequestInit): Promise<listUpcomingSessionsMeSessionsUpcomingGetResponse> => {
  
  return customInstance<listUpcomingSessionsMeSessionsUpcomingGetResponse>(getListUpcomingSessionsMeSessionsUpcomingGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getListUpcomingSessionsMeSessionsUpcomingGetQueryKey = () => {
    return [
    `/me/sessions/upcoming`
    ] as const;
    }

    
export const getListUpcomingSessionsMeSessionsUpcomingGetQueryOptions = <TData = Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUpcomingSessionsMeSessionsUpcomingGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>> = ({ signal }) => listUpcomingSessionsMeSessionsUpcomingGet({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUpcomingSessionsMeSessionsUpcomingGetQueryResult = NonNullable<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>>
export type ListUpcomingSessionsMeSessionsUpcomingGetQueryError = HTTPValidationError


export function useListUpcomingSessionsMeSessionsUpcomingGet<TData = Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>,
          TError,
          Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUpcomingSessionsMeSessionsUpcomingGet<TData = Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>,
          TError,
          Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUpcomingSessionsMeSessionsUpcomingGet<TData = Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Upcoming Sessions
 */

export function useListUpcomingSessionsMeSessionsUpcomingGet<TData = Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUpcomingSessionsMeSessionsUpcomingGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUpcomingSessionsMeSessionsUpcomingGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * A single session, participant-scoped, localized to the client's stored tz.
 * @summary Get Session
 */
export type getSessionMeSessionsSessionUuidGetResponse200 = {
  data: CoachedSessionOut
  status: 200
}

export type getSessionMeSessionsSessionUuidGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSessionMeSessionsSessionUuidGetResponseSuccess = (getSessionMeSessionsSessionUuidGetResponse200) & {
  headers: Headers;
};
export type getSessionMeSessionsSessionUuidGetResponseError = (getSessionMeSessionsSessionUuidGetResponse422) & {
  headers: Headers;
};

export type getSessionMeSessionsSessionUuidGetResponse = (getSessionMeSessionsSessionUuidGetResponseSuccess | getSessionMeSessionsSessionUuidGetResponseError)

export const getGetSessionMeSessionsSessionUuidGetUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}`
}

export const getSessionMeSessionsSessionUuidGet = async (sessionUuid: string, options?: RequestInit): Promise<getSessionMeSessionsSessionUuidGetResponse> => {
  
  return customInstance<getSessionMeSessionsSessionUuidGetResponse>(getGetSessionMeSessionsSessionUuidGetUrl(sessionUuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSessionMeSessionsSessionUuidGetQueryKey = (sessionUuid: string,) => {
    return [
    `/me/sessions/${sessionUuid}`
    ] as const;
    }

    
export const getGetSessionMeSessionsSessionUuidGetQueryOptions = <TData = Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError = HTTPValidationError>(sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionMeSessionsSessionUuidGetQueryKey(sessionUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>> = ({ signal }) => getSessionMeSessionsSessionUuidGet(sessionUuid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(sessionUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionMeSessionsSessionUuidGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>>
export type GetSessionMeSessionsSessionUuidGetQueryError = HTTPValidationError


export function useGetSessionMeSessionsSessionUuidGet<TData = Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError = HTTPValidationError>(
 sessionUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>,
          TError,
          Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionMeSessionsSessionUuidGet<TData = Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>,
          TError,
          Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionMeSessionsSessionUuidGet<TData = Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session
 */

export function useGetSessionMeSessionsSessionUuidGet<TData = Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionMeSessionsSessionUuidGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionMeSessionsSessionUuidGetQueryOptions(sessionUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Cancel the session — one-cancel-ends (§5.4).

Only a participant may cancel; status → canceled + an immutable cancel event, and (when
invites exist) the per-recipient Cronofy cancels + notifications fan out. The slot +
assignment are untouched, so the series carries next week. Canceling a completed session
is a 409.
 * @summary Cancel Session
 */
export type cancelSessionMeSessionsSessionUuidCancelPostResponse200 = {
  data: SessionCancelOut
  status: 200
}

export type cancelSessionMeSessionsSessionUuidCancelPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type cancelSessionMeSessionsSessionUuidCancelPostResponseSuccess = (cancelSessionMeSessionsSessionUuidCancelPostResponse200) & {
  headers: Headers;
};
export type cancelSessionMeSessionsSessionUuidCancelPostResponseError = (cancelSessionMeSessionsSessionUuidCancelPostResponse422) & {
  headers: Headers;
};

export type cancelSessionMeSessionsSessionUuidCancelPostResponse = (cancelSessionMeSessionsSessionUuidCancelPostResponseSuccess | cancelSessionMeSessionsSessionUuidCancelPostResponseError)

export const getCancelSessionMeSessionsSessionUuidCancelPostUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/cancel`
}

export const cancelSessionMeSessionsSessionUuidCancelPost = async (sessionUuid: string,
    sessionCancelIn: SessionCancelIn, options?: RequestInit): Promise<cancelSessionMeSessionsSessionUuidCancelPostResponse> => {
  
  return customInstance<cancelSessionMeSessionsSessionUuidCancelPostResponse>(getCancelSessionMeSessionsSessionUuidCancelPostUrl(sessionUuid),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionCancelIn,)
  }
);}
  



export const getCancelSessionMeSessionsSessionUuidCancelPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>, TError,{sessionUuid: string;data: SessionCancelIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>, TError,{sessionUuid: string;data: SessionCancelIn}, TContext> => {

const mutationKey = ['cancelSessionMeSessionsSessionUuidCancelPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>, {sessionUuid: string;data: SessionCancelIn}> = (props) => {
          const {sessionUuid,data} = props ?? {};

          return  cancelSessionMeSessionsSessionUuidCancelPost(sessionUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CancelSessionMeSessionsSessionUuidCancelPostMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>>
    export type CancelSessionMeSessionsSessionUuidCancelPostMutationBody = SessionCancelIn
    export type CancelSessionMeSessionsSessionUuidCancelPostMutationError = HTTPValidationError

    /**
 * @summary Cancel Session
 */
export const useCancelSessionMeSessionsSessionUuidCancelPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>, TError,{sessionUuid: string;data: SessionCancelIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSessionMeSessionsSessionUuidCancelPost>>,
        TError,
        {sessionUuid: string;data: SessionCancelIn},
        TContext
      > => {
      return useMutation(getCancelSessionMeSessionsSessionUuidCancelPostMutationOptions(options), queryClient);
    }
    /**
 * The ACTING person's check-in state for a session (theirs only — P1).
 * @summary Get Session Checkin
 */
export type getSessionCheckinResponse200 = {
  data: CheckinStateOut
  status: 200
}

export type getSessionCheckinResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSessionCheckinResponseSuccess = (getSessionCheckinResponse200) & {
  headers: Headers;
};
export type getSessionCheckinResponseError = (getSessionCheckinResponse422) & {
  headers: Headers;
};

export type getSessionCheckinResponse = (getSessionCheckinResponseSuccess | getSessionCheckinResponseError)

export const getGetSessionCheckinUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/checkin`
}

export const getSessionCheckin = async (sessionUuid: string, options?: RequestInit): Promise<getSessionCheckinResponse> => {
  
  return customInstance<getSessionCheckinResponse>(getGetSessionCheckinUrl(sessionUuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSessionCheckinQueryKey = (sessionUuid: string,) => {
    return [
    `/me/sessions/${sessionUuid}/checkin`
    ] as const;
    }

    
export const getGetSessionCheckinQueryOptions = <TData = Awaited<ReturnType<typeof getSessionCheckin>>, TError = HTTPValidationError>(sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionCheckinQueryKey(sessionUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionCheckin>>> = ({ signal }) => getSessionCheckin(sessionUuid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(sessionUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionCheckinQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionCheckin>>>
export type GetSessionCheckinQueryError = HTTPValidationError


export function useGetSessionCheckin<TData = Awaited<ReturnType<typeof getSessionCheckin>>, TError = HTTPValidationError>(
 sessionUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionCheckin>>,
          TError,
          Awaited<ReturnType<typeof getSessionCheckin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionCheckin<TData = Awaited<ReturnType<typeof getSessionCheckin>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionCheckin>>,
          TError,
          Awaited<ReturnType<typeof getSessionCheckin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionCheckin<TData = Awaited<ReturnType<typeof getSessionCheckin>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session Checkin
 */

export function useGetSessionCheckin<TData = Awaited<ReturnType<typeof getSessionCheckin>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionCheckin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionCheckinQueryOptions(sessionUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Save the acting person's final check-in answers before the session starts.
 * @summary Put Session Checkin
 */
export type putSessionCheckinResponse200 = {
  data: CheckinStateOut
  status: 200
}

export type putSessionCheckinResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type putSessionCheckinResponseSuccess = (putSessionCheckinResponse200) & {
  headers: Headers;
};
export type putSessionCheckinResponseError = (putSessionCheckinResponse422) & {
  headers: Headers;
};

export type putSessionCheckinResponse = (putSessionCheckinResponseSuccess | putSessionCheckinResponseError)

export const getPutSessionCheckinUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/checkin`
}

export const putSessionCheckin = async (sessionUuid: string,
    checkinIn: CheckinIn, options?: RequestInit): Promise<putSessionCheckinResponse> => {
  
  return customInstance<putSessionCheckinResponse>(getPutSessionCheckinUrl(sessionUuid),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkinIn,)
  }
);}
  



export const getPutSessionCheckinMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSessionCheckin>>, TError,{sessionUuid: string;data: CheckinIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSessionCheckin>>, TError,{sessionUuid: string;data: CheckinIn}, TContext> => {

const mutationKey = ['putSessionCheckin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSessionCheckin>>, {sessionUuid: string;data: CheckinIn}> = (props) => {
          const {sessionUuid,data} = props ?? {};

          return  putSessionCheckin(sessionUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutSessionCheckinMutationResult = NonNullable<Awaited<ReturnType<typeof putSessionCheckin>>>
    export type PutSessionCheckinMutationBody = CheckinIn
    export type PutSessionCheckinMutationError = HTTPValidationError

    /**
 * @summary Put Session Checkin
 */
export const usePutSessionCheckin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSessionCheckin>>, TError,{sessionUuid: string;data: CheckinIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSessionCheckin>>,
        TError,
        {sessionUuid: string;data: CheckinIn},
        TContext
      > => {
      return useMutation(getPutSessionCheckinMutationOptions(options), queryClient);
    }
    /**
 * Confirm attendance through the participant-authenticated in-app path (§5.2).

Only a participant of the session may confirm; tentative → confirmed + an immutable
confirm event. Confirming a canceled session is a 409.
 * @summary Confirm Session
 */
export type confirmSessionMeSessionsSessionUuidConfirmPostResponse200 = {
  data: SessionConfirmOut
  status: 200
}

export type confirmSessionMeSessionsSessionUuidConfirmPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type confirmSessionMeSessionsSessionUuidConfirmPostResponseSuccess = (confirmSessionMeSessionsSessionUuidConfirmPostResponse200) & {
  headers: Headers;
};
export type confirmSessionMeSessionsSessionUuidConfirmPostResponseError = (confirmSessionMeSessionsSessionUuidConfirmPostResponse422) & {
  headers: Headers;
};

export type confirmSessionMeSessionsSessionUuidConfirmPostResponse = (confirmSessionMeSessionsSessionUuidConfirmPostResponseSuccess | confirmSessionMeSessionsSessionUuidConfirmPostResponseError)

export const getConfirmSessionMeSessionsSessionUuidConfirmPostUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/confirm`
}

export const confirmSessionMeSessionsSessionUuidConfirmPost = async (sessionUuid: string, options?: RequestInit): Promise<confirmSessionMeSessionsSessionUuidConfirmPostResponse> => {
  
  return customInstance<confirmSessionMeSessionsSessionUuidConfirmPostResponse>(getConfirmSessionMeSessionsSessionUuidConfirmPostUrl(sessionUuid),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getConfirmSessionMeSessionsSessionUuidConfirmPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>, TError,{sessionUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>, TError,{sessionUuid: string}, TContext> => {

const mutationKey = ['confirmSessionMeSessionsSessionUuidConfirmPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>, {sessionUuid: string}> = (props) => {
          const {sessionUuid} = props ?? {};

          return  confirmSessionMeSessionsSessionUuidConfirmPost(sessionUuid,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmSessionMeSessionsSessionUuidConfirmPostMutationResult = NonNullable<Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>>
    
    export type ConfirmSessionMeSessionsSessionUuidConfirmPostMutationError = HTTPValidationError

    /**
 * @summary Confirm Session
 */
export const useConfirmSessionMeSessionsSessionUuidConfirmPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>, TError,{sessionUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmSessionMeSessionsSessionUuidConfirmPost>>,
        TError,
        {sessionUuid: string},
        TContext
      > => {
      return useMutation(getConfirmSessionMeSessionsSessionUuidConfirmPostMutationOptions(options), queryClient);
    }
    /**
 * Decline the session TIME without canceling the session (Option-2 §5.5 split).

Marks the caller's recipient row DECLINED and notifies the therapist (one-click
reschedule deeplink) — the session is NOT canceled (spec §7.4: a single decline never
auto-cancels; "this time doesn't work" ≠ "we don't want the session"). Existing
``/cancel`` keeps its one-cancel-ends semantics verbatim. Participant-scoped 404-not-403;
declining a canceled/completed session is a 409. An optional ``reason`` lands on the
caller's recipient ``comment`` (the same field callback reply-comments use).
 * @summary Decline Session
 */
export type declineSessionMeSessionsSessionUuidDeclinePostResponse200 = {
  data: SessionDeclineOut
  status: 200
}

export type declineSessionMeSessionsSessionUuidDeclinePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type declineSessionMeSessionsSessionUuidDeclinePostResponseSuccess = (declineSessionMeSessionsSessionUuidDeclinePostResponse200) & {
  headers: Headers;
};
export type declineSessionMeSessionsSessionUuidDeclinePostResponseError = (declineSessionMeSessionsSessionUuidDeclinePostResponse422) & {
  headers: Headers;
};

export type declineSessionMeSessionsSessionUuidDeclinePostResponse = (declineSessionMeSessionsSessionUuidDeclinePostResponseSuccess | declineSessionMeSessionsSessionUuidDeclinePostResponseError)

export const getDeclineSessionMeSessionsSessionUuidDeclinePostUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/decline`
}

export const declineSessionMeSessionsSessionUuidDeclinePost = async (sessionUuid: string,
    sessionDeclineIn: SessionDeclineIn, options?: RequestInit): Promise<declineSessionMeSessionsSessionUuidDeclinePostResponse> => {
  
  return customInstance<declineSessionMeSessionsSessionUuidDeclinePostResponse>(getDeclineSessionMeSessionsSessionUuidDeclinePostUrl(sessionUuid),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionDeclineIn,)
  }
);}
  



export const getDeclineSessionMeSessionsSessionUuidDeclinePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>, TError,{sessionUuid: string;data: SessionDeclineIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>, TError,{sessionUuid: string;data: SessionDeclineIn}, TContext> => {

const mutationKey = ['declineSessionMeSessionsSessionUuidDeclinePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>, {sessionUuid: string;data: SessionDeclineIn}> = (props) => {
          const {sessionUuid,data} = props ?? {};

          return  declineSessionMeSessionsSessionUuidDeclinePost(sessionUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineSessionMeSessionsSessionUuidDeclinePostMutationResult = NonNullable<Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>>
    export type DeclineSessionMeSessionsSessionUuidDeclinePostMutationBody = SessionDeclineIn
    export type DeclineSessionMeSessionsSessionUuidDeclinePostMutationError = HTTPValidationError

    /**
 * @summary Decline Session
 */
export const useDeclineSessionMeSessionsSessionUuidDeclinePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>, TError,{sessionUuid: string;data: SessionDeclineIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineSessionMeSessionsSessionUuidDeclinePost>>,
        TError,
        {sessionUuid: string;data: SessionDeclineIn},
        TContext
      > => {
      return useMutation(getDeclineSessionMeSessionsSessionUuidDeclinePostMutationOptions(options), queryClient);
    }
    /**
 * The ACTING person's feedback state for a session (theirs only — P1).
 * @summary Get Session Feedback
 */
export type getSessionFeedbackResponse200 = {
  data: FeedbackStateOut
  status: 200
}

export type getSessionFeedbackResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSessionFeedbackResponseSuccess = (getSessionFeedbackResponse200) & {
  headers: Headers;
};
export type getSessionFeedbackResponseError = (getSessionFeedbackResponse422) & {
  headers: Headers;
};

export type getSessionFeedbackResponse = (getSessionFeedbackResponseSuccess | getSessionFeedbackResponseError)

export const getGetSessionFeedbackUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/feedback`
}

export const getSessionFeedback = async (sessionUuid: string, options?: RequestInit): Promise<getSessionFeedbackResponse> => {
  
  return customInstance<getSessionFeedbackResponse>(getGetSessionFeedbackUrl(sessionUuid),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSessionFeedbackQueryKey = (sessionUuid: string,) => {
    return [
    `/me/sessions/${sessionUuid}/feedback`
    ] as const;
    }

    
export const getGetSessionFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getSessionFeedback>>, TError = HTTPValidationError>(sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionFeedbackQueryKey(sessionUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionFeedback>>> = ({ signal }) => getSessionFeedback(sessionUuid, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(sessionUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionFeedback>>>
export type GetSessionFeedbackQueryError = HTTPValidationError


export function useGetSessionFeedback<TData = Awaited<ReturnType<typeof getSessionFeedback>>, TError = HTTPValidationError>(
 sessionUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionFeedback>>,
          TError,
          Awaited<ReturnType<typeof getSessionFeedback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionFeedback<TData = Awaited<ReturnType<typeof getSessionFeedback>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionFeedback>>,
          TError,
          Awaited<ReturnType<typeof getSessionFeedback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionFeedback<TData = Awaited<ReturnType<typeof getSessionFeedback>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session Feedback
 */

export function useGetSessionFeedback<TData = Awaited<ReturnType<typeof getSessionFeedback>>, TError = HTTPValidationError>(
 sessionUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionFeedback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionFeedbackQueryOptions(sessionUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Save the acting person's final feedback answers (no close in v1).
 * @summary Put Session Feedback
 */
export type putSessionFeedbackResponse200 = {
  data: FeedbackStateOut
  status: 200
}

export type putSessionFeedbackResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type putSessionFeedbackResponseSuccess = (putSessionFeedbackResponse200) & {
  headers: Headers;
};
export type putSessionFeedbackResponseError = (putSessionFeedbackResponse422) & {
  headers: Headers;
};

export type putSessionFeedbackResponse = (putSessionFeedbackResponseSuccess | putSessionFeedbackResponseError)

export const getPutSessionFeedbackUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/feedback`
}

export const putSessionFeedback = async (sessionUuid: string,
    feedbackIn: FeedbackIn, options?: RequestInit): Promise<putSessionFeedbackResponse> => {
  
  return customInstance<putSessionFeedbackResponse>(getPutSessionFeedbackUrl(sessionUuid),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      feedbackIn,)
  }
);}
  



export const getPutSessionFeedbackMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSessionFeedback>>, TError,{sessionUuid: string;data: FeedbackIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSessionFeedback>>, TError,{sessionUuid: string;data: FeedbackIn}, TContext> => {

const mutationKey = ['putSessionFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSessionFeedback>>, {sessionUuid: string;data: FeedbackIn}> = (props) => {
          const {sessionUuid,data} = props ?? {};

          return  putSessionFeedback(sessionUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutSessionFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof putSessionFeedback>>>
    export type PutSessionFeedbackMutationBody = FeedbackIn
    export type PutSessionFeedbackMutationError = HTTPValidationError

    /**
 * @summary Put Session Feedback
 */
export const usePutSessionFeedback = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSessionFeedback>>, TError,{sessionUuid: string;data: FeedbackIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSessionFeedback>>,
        TError,
        {sessionUuid: string;data: FeedbackIn},
        TContext
      > => {
      return useMutation(getPutSessionFeedbackMutationOptions(options), queryClient);
    }
    /**
 * Release one occurrence and persist A's selected subset for the other partner.
 * @summary Create Reschedule Offer
 */
export type createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse200 = {
  data: RescheduleOfferMutationOut
  status: 200
}

export type createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponseSuccess = (createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse200) & {
  headers: Headers;
};
export type createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponseError = (createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse422) & {
  headers: Headers;
};

export type createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse = (createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponseSuccess | createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponseError)

export const getCreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/reschedule-offers`
}

export const createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost = async (sessionUuid: string,
    rescheduleOfferCreateIn: RescheduleOfferCreateIn, options?: RequestInit): Promise<createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse> => {
  
  return customInstance<createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostResponse>(getCreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostUrl(sessionUuid),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rescheduleOfferCreateIn,)
  }
);}
  



export const getCreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>, TError,{sessionUuid: string;data: RescheduleOfferCreateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>, TError,{sessionUuid: string;data: RescheduleOfferCreateIn}, TContext> => {

const mutationKey = ['createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>, {sessionUuid: string;data: RescheduleOfferCreateIn}> = (props) => {
          const {sessionUuid,data} = props ?? {};

          return  createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost(sessionUuid,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>>
    export type CreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostMutationBody = RescheduleOfferCreateIn
    export type CreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostMutationError = HTTPValidationError

    /**
 * @summary Create Reschedule Offer
 */
export const useCreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>, TError,{sessionUuid: string;data: RescheduleOfferCreateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRescheduleOfferMeSessionsSessionUuidRescheduleOffersPost>>,
        TError,
        {sessionUuid: string;data: RescheduleOfferCreateIn},
        TContext
      > => {
      return useMutation(getCreateRescheduleOfferMeSessionsSessionUuidRescheduleOffersPostMutationOptions(options), queryClient);
    }
    /**
 * Return up to five live-verified same-duration choices (at least one), or fail closed when none remain.
 * @summary Generate Reschedule Slot Set
 */
export type generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse200 = {
  data: RescheduleCandidateSetOut
  status: 200
}

export type generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponseSuccess = (generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse200) & {
  headers: Headers;
};
export type generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponseError = (generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse422) & {
  headers: Headers;
};

export type generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse = (generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponseSuccess | generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponseError)

export const getGenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostUrl = (sessionUuid: string,) => {


  

  return `/me/sessions/${sessionUuid}/reschedule-slot-sets`
}

export const generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost = async (sessionUuid: string, options?: RequestInit): Promise<generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse> => {
  
  return customInstance<generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostResponse>(getGenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostUrl(sessionUuid),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getGenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>, TError,{sessionUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>, TError,{sessionUuid: string}, TContext> => {

const mutationKey = ['generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>, {sessionUuid: string}> = (props) => {
          const {sessionUuid} = props ?? {};

          return  generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost(sessionUuid,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostMutationResult = NonNullable<Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>>
    
    export type GenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostMutationError = HTTPValidationError

    /**
 * @summary Generate Reschedule Slot Set
 */
export const useGenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>, TError,{sessionUuid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPost>>,
        TError,
        {sessionUuid: string},
        TContext
      > => {
      return useMutation(getGenerateRescheduleSlotSetMeSessionsSessionUuidRescheduleSlotSetsPostMutationOptions(options), queryClient);
    }
    